<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="$router.push('/tipster/panel')">Panel Tipster</span>
        &gt; Suscripciones
      </p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
            <div>
              <h5 class="mb-1">Suscripciones</h5>
              <p class="text-sm opacity-7 mb-0">Listado completo de suscriptores por tipster</p>
            </div>
          </div>

          <!-- Selector tipster (solo admin) -->
          <div v-if="canAdmin" class="selector-row px-4 pb-3">
            <div class="select-block">
              <label class="text-sm mb-2">Tipster</label>
              <div class="select-wrap">
                <select class="form-select" v-model="tipsterId">
                  <option value="">-- Yo (mi tipster) --</option>
                  <option v-for="t in tipsters" :key="t.id" :value="String(t.id)">{{ t.nombre }}</option>
                </select>
              </div>
            </div>
            <div class="selector-actions">
              <QBtn variant="tipster" label="Cargar" :loading="loading" :disabled="loading" @click="cargar" />
            </div>
          </div>

          <!-- Filtros de fecha -->
          <div class="susc-periodo-wrap px-4 pb-2">
            <div class="periodo-btns">
              <button v-for="p in periodos" :key="p.value"
                :class="['btn-periodo', { active: periodoActivo === p.value }]"
                @click="aplicarPeriodo(p.value)">
                <i v-if="p.value === 'custom'" class="fas fa-calendar-alt me-1"></i>
                {{ p.label }}
              </button>
            </div>
            <div v-if="periodoActivo === 'custom'" class="custom-dates mt-2">
              <input type="date" v-model="fechaDesde" class="form-control date-input" :max="fechaHasta || undefined" />
              <span class="sep-dash">—</span>
              <input type="date" v-model="fechaHasta" class="form-control date-input" :min="fechaDesde || undefined" />
              <button class="btn-periodo active" :disabled="!fechaDesde || !fechaHasta" @click="cargar">Aplicar</button>
            </div>
            <div class="susc-tipo-fecha-row mt-2">
              <span class="susc-tipo-label">Filtrar por fecha de:</span>
              <button :class="['btn-tipo-fecha', 'btn-tipo-alta', { active: tipoFecha === 'alta' }]" @click="setTipoFecha('alta')">
                <i class="fas fa-user-plus"></i> Altas
              </button>
              <button :class="['btn-tipo-fecha', 'btn-tipo-renov', { active: tipoFecha === 'renovacion' }]" @click="setTipoFecha('renovacion')">
                <i class="fas fa-rotate"></i> Renovaciones
              </button>
              <span v-if="tipoFecha" class="susc-tipo-hint">
                {{ tipoFecha === 'alta' ? 'Mostrando suscripciones dadas de alta en el periodo seleccionado' : 'Mostrando suscripciones con renovación en el periodo seleccionado' }}
              </span>
            </div>
          </div>

          <!-- Toolbar: buscador + filtro estado -->
          <div class="toolbar-susc px-4 pb-3" style="position:relative">
            <input
              v-model="filtroTexto"
              type="text"
              class="input-buscar"
              placeholder="Buscar por email, nombre, producto…"
              @input="onBuscar"
            />
            <div class="leyenda-estados">
              <button class="ley-item" :class="{ 'ley-activo': filtroEstado === 'activa' }" @click="setEstado('activa')">
                <span class="badge-susc badge-activa">Activa</span>
              </button>
              <button class="ley-item" :class="{ 'ley-activo': filtroEstado === 'gracia' }" @click="setEstado('gracia')">
                <span class="badge-susc badge-gracia">En gracia</span>
              </button>
              <button class="ley-item" :class="{ 'ley-activo': filtroEstado === 'vencida' }" @click="setEstado('vencida')">
                <span class="badge-susc badge-vencida">Vencida</span>
              </button>
              <button class="ley-item" :class="{ 'ley-activo': filtroEstado === 'cancelada' }" @click="setEstado('cancelada')">
                <span class="badge-susc badge-cancelada">Cancelada</span>
              </button>
              <button class="ley-item" :class="{ 'ley-activo': filtroEstado === '' }" @click="setEstado('')">
                <span class="badge-susc badge-todos">Todos</span>
              </button>
            </div>
            <span class="total-label" v-if="!loading">{{ total }} resultado{{ total !== 1 ? 's' : '' }}</span>
            <button
              class="btn-reintentar-masivo"
              :class="{ 'cargando': reintentandoTodos }"
              :disabled="reintentandoTodos"
              @click="reintentarTodos"
              title="Reintentar cobro en todas las suscripciones en gracia o vencidas"
            >
              <span v-if="reintentandoTodos"><i class="fas fa-spinner fa-spin me-1"></i>Reintentando…</span>
              <span v-else><i class="fas fa-rotate me-1"></i>Reintentar todos</span>
            </button>
            <button class="btn-cols-toggle" @click="selectorColsAbierto = !selectorColsAbierto" title="Columnas visibles">
              <i class="fas fa-columns"></i>
            </button>
            <!-- Panel selector columnas -->
            <div v-if="selectorColsAbierto" class="selector-columnas-panel" v-click-outside="() => selectorColsAbierto = false">
              <div class="selector-columnas-header">
                <span>Columnas visibles</span>
                <button class="selector-reset" @click="resetCols">Restablecer</button>
              </div>
              <div class="selector-columnas-grid">
                <label v-for="col in colsConfig" :key="col.key" class="selector-col-item">
                  <input type="checkbox" v-model="colsV[col.key]" @change="guardarCols" />
                  <span class="selector-col-dot" :style="{ background: col.color }"></span>
                  <span>{{ col.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla -->
        <div class="card mt-3">
          <div class="px-4 pb-4 card-body">
            <div class="tabla-wrap">
              <table class="tabla-susc">
                <thead>
                  <tr>
                    <th @click="ordenar('estado')" class="th-ord" :class="{'d-none': !colsV.estado}">Estado <span class="ord-icon">{{ iconOrden('estado') }}</span></th>
                    <th @click="ordenar('suscripcion_id')" class="th-ord" :class="{'d-none': !colsV.suscripcion}">Suscripción <span class="ord-icon">{{ iconOrden('suscripcion_id') }}</span></th>
                    <th @click="ordenar('producto')" class="th-ord" :class="{'d-none': !colsV.producto}">Producto <span class="ord-icon">{{ iconOrden('producto') }}</span></th>
                    <th @click="ordenar('importe')" class="th-ord" :class="{'d-none': !colsV.importe}">Total <span class="ord-icon">{{ iconOrden('importe') }}</span></th>
                    <th @click="ordenar('fecha_alta')" class="th-ord" :class="{'d-none': !colsV.fecha_inicio}">Fecha inicio <span class="ord-icon">{{ iconOrden('fecha_alta') }}</span></th>
                    <th @click="ordenar('periodo_fin')" class="th-ord" :class="{'d-none': !colsV.siguiente_pago}">Siguiente pago <span class="ord-icon">{{ iconOrden('periodo_fin') }}</span></th>
                    <th @click="ordenar('ultimo_pago_at')" class="th-ord" :class="{'d-none': !colsV.ultimo_cobro}">Último cobro <span class="ord-icon">{{ iconOrden('ultimo_pago_at') }}</span></th>
                    <th @click="ordenar('fecha_fin')" class="th-ord" :class="{'d-none': !colsV.fecha_fin}">Fecha fin <span class="ord-icon">{{ iconOrden('fecha_fin') }}</span></th>
                    <th @click="ordenar('num_pagos')" class="th-ord" :class="{'d-none': !colsV.pagos}">Pagos <span class="ord-icon">{{ iconOrden('num_pagos') }}</span></th>
                    <th class="th-acciones">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="10" class="text-center py-5 opacity-5">Cargando…</td>
                  </tr>
                  <tr v-else-if="filasPaginadas.length === 0">
                    <td colspan="10" class="text-center py-5 opacity-5">Sin resultados</td>
                  </tr>
                  <tr v-for="s in filasPaginadas" :key="s.suscripcion_id" class="fila-susc">
                    <td class="td-estado" :class="{'d-none': !colsV.estado}">
                      <div class="susc-estado-cel">
                        <span :class="['badge-susc', badgeClase(s.estado)]">{{ estadoLabel(s.estado) }}</span>
                        <span v-if="s.cancelacion_programada" class="susc-cancel-prog-chip">En proceso de cancelación</span>
                      </div>
                      <span v-if="s.kick_telegram_ok === false"
                        class="badge-kick-fallo"
                        title="⚠️ Expulsión Telegram fallida — el usuario puede seguir en el canal">
                        ⚠️ kick
                      </span>
                    </td>
                    <td class="td-susc" :class="{'d-none': !colsV.suscripcion}">
                      <span class="susc-id">#{{ s.suscripcion_id }}</span>
                      <div class="susc-cliente">
                        <span class="susc-nombre">{{ s.nombre_usuario || '—' }}</span>
                        <span class="susc-email">{{ s.email }}</span>
                      </div>
                    </td>
                    <td class="td-prod" :class="{'d-none': !colsV.producto}">
                      <span class="prod-nombre">{{ s.producto }}</span>
                      <span class="prod-ciclo">{{ cicloLabel(s.tipo_venta) }}</span>
                    </td>
                    <td class="td-total" :class="{'d-none': !colsV.importe}">
                      {{ fmtMoney(s.importe, s.moneda) }}
                      <span class="ciclo-abbr">/ {{ cicloCorto(s.tipo_venta) }}</span>
                    </td>
                    <td class="td-fecha" :class="{'d-none': !colsV.fecha_inicio}">
                      <span class="fecha-dia">{{ fmtFechaHora(s.fecha_alta) }}</span>
                      <span class="fecha-hora">{{ fmtHora(s.fecha_alta) }}</span>
                    </td>
                    <td class="td-fecha" :class="{'d-none': !colsV.siguiente_pago}">
                      <span v-if="s.estado === 'activa'" :class="esProximo(s.periodo_fin) ? 'text-warning' : ''">
                        <span class="fecha-dia">{{ fmtFechaHora(s.periodo_fin) }}</span>
                        <span class="fecha-hora">{{ fmtHora(s.periodo_fin) }}</span>
                      </span>
                      <span v-else class="opacity-4">—</span>
                    </td>
                    <td class="td-fecha" :class="{'d-none': !colsV.ultimo_cobro}">
                      <span v-if="s.ultimo_pago_at">
                        <span class="fecha-dia">{{ fmtFechaHora(s.ultimo_pago_at) }}</span>
                        <span class="fecha-hora">{{ fmtHora(s.ultimo_pago_at) }}</span>
                      </span>
                      <span v-else class="opacity-4">—</span>
                    </td>
                    <td class="td-fecha" :class="{'d-none': !colsV.fecha_fin}">
                      <span v-if="s.cancelada_at" class="text-danger-soft">
                        <span class="fecha-dia">{{ fmtFechaHora(s.cancelada_at) }}</span>
                        <span class="fecha-hora">{{ fmtHora(s.cancelada_at) }}</span>
                      </span>
                      <span v-else-if="s.vencida_at" class="text-muted-soft">
                        <span class="fecha-dia">{{ fmtFechaHora(s.vencida_at) }}</span>
                        <span class="fecha-hora">{{ fmtHora(s.vencida_at) }}</span>
                      </span>
                      <span v-else class="opacity-4">—</span>
                    </td>
                    <td class="td-pagos" :class="{'d-none': !colsV.pagos}">
                      <span class="num-pagos">{{ s.num_pagos }}</span>
                    </td>
                    <td class="td-acciones">
                      <button
                        v-if="s.estado === 'vencida' || s.estado === 'gracia'"
                        class="btn-reintentar"
                        :class="{ 'cargando': reintentando === s.suscripcion_id }"
                        :disabled="reintentando === s.suscripcion_id"
                        @click="reintentar(s)"
                        title="Reintentar pago en Stripe"
                      >
                        <span v-if="reintentando === s.suscripcion_id">…</span>
                        <span v-else>↻ Reintentar</span>
                      </button>
                      <button
                        v-if="s.pedido_id"
                        class="btn-stripe-resp"
                        :class="{ 'cargando': stripeResp.loading === s.suscripcion_id }"
                        :disabled="stripeResp.loading === s.suscripcion_id"
                        @click="verRespStripe(s)"
                        title="Ver última respuesta de Stripe"
                      >
                        <span v-if="stripeResp.loading === s.suscripcion_id">…</span>
                        <span v-else>⚡ Resp. Stripe</span>
                      </button>
                      <button
                        v-if="s.pedido_id"
                        class="btn-hist-pagos"
                        :class="{ 'cargando': historial.loading === s.suscripcion_id }"
                        :disabled="historial.loading === s.suscripcion_id"
                        @click="abrirHistorial(s)"
                        title="Ver historial de pagos"
                      >
                        <span v-if="historial.loading === s.suscripcion_id">…</span>
                        <span v-else>📋 Historial</span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginación -->
            <div v-if="totalPaginas > 1" class="paginacion mt-3">
              <button class="btn-pag" :disabled="paginaActual === 1" @click="paginaActual--">‹</button>
              <span class="pag-info">{{ paginaActual }} / {{ totalPaginas }}</span>
              <button class="btn-pag" :disabled="paginaActual === totalPaginas" @click="paginaActual++">›</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal respuesta Stripe -->
  <Teleport to="body">
    <div v-if="stripeResp.visible" class="sresp-overlay" @click.self="stripeResp.visible = false">
      <div class="sresp-box">
        <div class="sresp-head">
          <div>
            <span class="sresp-title">Última respuesta de Stripe</span>
            <p class="sresp-sub">{{ stripeResp.email }} · {{ stripeResp.producto }}</p>
          </div>
          <button class="sresp-close" @click="stripeResp.visible = false">×</button>
        </div>
        <div class="sresp-body">
          <!-- Pago exitoso -->
          <div v-if="stripeResp.tipo === 'pago_ok' || stripeResp.tipo === 'pago_recuperado'" class="sresp-resultado sresp-ok">
            <span class="sresp-icon">✓</span>
            <div>
              <div class="sresp-resultado-label">{{ stripeResp.tipo === 'pago_recuperado' ? 'Pago recuperado' : 'Pago realizado' }}</div>
              <div v-if="stripeResp.importe" class="sresp-resultado-detalle">
                {{ fmtMoney(stripeResp.importe, stripeResp.moneda) }}
                <span v-if="stripeResp.fecha"> · {{ fmtFecha(stripeResp.fecha) }}</span>
              </div>
            </div>
          </div>
          <!-- Pago fallido -->
          <div v-else-if="stripeResp.tipo === 'pago_fallido'" class="sresp-resultado sresp-error">
            <span class="sresp-icon">⚠</span>
            <div>
              <div class="sresp-resultado-label">Pago fallido</div>
              <div class="sresp-resultado-detalle">
                {{ stripeResp.motivo || 'Sin detalle disponible en Stripe' }}
              </div>
            </div>
          </div>
          <!-- Cancelada sin cobros -->
          <div v-else-if="stripeResp.tipo === 'cancelada'" class="sresp-resultado sresp-cancelada">
            <span class="sresp-icon">✗</span>
            <div>
              <div class="sresp-resultado-label">Suscripción cancelada</div>
              <div v-if="stripeResp.fecha" class="sresp-resultado-detalle">
                Sin cobros registrados · {{ fmtFecha(stripeResp.fecha) }}
              </div>
              <div v-else class="sresp-resultado-detalle">Sin cobros registrados</div>
            </div>
          </div>
          <!-- Sin datos -->
          <div v-else class="sresp-vacio">
            Sin registros de pago disponibles.
          </div>
        </div>
        <div class="sresp-foot">
          <button class="btn-q-secondary" @click="stripeResp.visible = false">Cerrar</button>
        </div>
      </div>
    </div>
  </Teleport>

  <!-- Modal historial de pagos -->
  <Teleport to="body">
    <div v-if="historial.visible" class="hist-overlay" @click.self="cerrarHistorial">
      <div class="hist-box">
        <div class="hist-head">
          <div>
            <span class="hist-title">Historial de pagos</span>
            <p class="hist-sub">{{ historial.email }} · {{ historial.producto }}</p>
          </div>
          <button class="hist-close" @click="cerrarHistorial">×</button>
        </div>
        <div class="hist-body">
          <div v-if="historial.loading" class="hist-empty">
            <span class="spinner-border spinner-border-sm me-2"></span>Cargando…
          </div>
          <div v-else-if="historial.eventos.length === 0" class="hist-empty">Sin registros de pagos.</div>
          <div v-else class="hist-timeline">
            <div v-for="(ev, idx) in historial.eventos" :key="idx" class="hist-item" :class="'hist-ev-' + ev.tipo">
              <div class="hist-dot"></div>
              <div class="hist-content">
                <div class="hist-label">{{ labelHistorial(ev.tipo, idx) }}</div>
                <div class="hist-fecha">{{ fmtFechaHora(ev.fecha) }} {{ fmtHora(ev.fecha) }}</div>
                <div v-if="ev.importe !== null && ev.importe > 0" class="hist-importe">
                  {{ fmtMoney(ev.importe, ev.moneda) }}
                </div>
                <div v-if="ev.tipo === 'pago_fallido' && ev.motivo" class="hist-motivo">{{ ev.motivo }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="hist-foot">
          <button class="btn-q-secondary" @click="cerrarHistorial">Cerrar</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import axios from "axios";
import showSwal from "@/mixins/showSwal.js";

const POR_PAGINA = 50;
let buscarTimer = null;

const COLS_STORAGE_KEY = 'susc_lista_cols_v1';
const COLS_DEFAULT = {
  estado: true, suscripcion: true, producto: true, importe: true,
  fecha_inicio: true, siguiente_pago: true, ultimo_cobro: true, fecha_fin: true, pagos: true,
};
const COLS_MOBILE = {
  estado: true, suscripcion: true, producto: false, importe: true,
  fecha_inicio: false, siguiente_pago: false, ultimo_cobro: false, fecha_fin: true, pagos: false,
};

export default {
  name: "SuscripcionesListaTipster",
  directives: {
    clickOutside: {
      beforeMount(el, binding) {
        el._clickOutside = (e) => { if (!el.contains(e.target)) binding.value(e); };
        setTimeout(() => document.addEventListener('click', el._clickOutside), 0);
      },
      unmounted(el) { document.removeEventListener('click', el._clickOutside); },
    },
  },
  data() {
    return {
      loading: false,
      reintentando: null,
      reintentandoTodos: false,
      stripeResp: { visible: false, loading: null, tipo: null, motivo: null, importe: null, moneda: null, fecha: null, email: null, producto: null },
      historial: { visible: false, loading: null, eventos: [], email: null, producto: null },
      tipsters: [],
      tipsterId: "",
      lista: [],
      total: 0,
      filtroTexto: "",
      filtroEstado: "",
      ordenCampo: "fecha_alta",
      ordenDir: "desc",
      paginaActual: 1,
      selectorColsAbierto: false,
      colsV: { ...COLS_DEFAULT },
      periodoActivo: 'all',
      fechaDesde: '',
      fechaHasta: '',
      tipoFecha: null,
      periodos: [
        { value: 'mes',      label: 'Mes actual' },
        { value: 'hoy',      label: 'Hoy' },
        { value: 'hoy_ayer', label: 'Hoy y Ayer' },
        { value: 'anio',     label: 'Este año' },
        { value: 'all',      label: 'Todo' },
        { value: 'custom',   label: 'Personalizado' },
      ],
    };
  },
  computed: {
    colsConfig() {
      return [
        { key: 'estado',        label: 'Estado',         color: '#6b7280' },
        { key: 'suscripcion',   label: 'Suscripción',    color: '#6b7280' },
        { key: 'producto',      label: 'Producto',       color: '#6b7280' },
        { key: 'importe',       label: 'Total',          color: '#00e676' },
        { key: 'fecha_inicio',  label: 'Fecha inicio',   color: '#6b7280' },
        { key: 'siguiente_pago',label: 'Siguiente pago', color: '#6b7280' },
        { key: 'ultimo_cobro',  label: 'Último cobro',   color: '#00e676' },
        { key: 'fecha_fin',     label: 'Fecha fin',      color: '#6b7280' },
        { key: 'pagos',         label: 'Pagos',          color: '#6b7280' },
      ];
    },
    permisos() { return this.$store.state.auth?.permisos_finales || []; },
    permisosListos() { return Array.isArray(this.permisos) && this.permisos.length > 0; },
    canAdmin() {
      return Array.isArray(this.permisos) && this.permisos.includes("panel_tipster.admin.ver");
    },
    filasFiltradas() {
      const campo = this.ordenCampo;
      const dir   = this.ordenDir === "asc" ? 1 : -1;
      return [...this.lista].sort((a, b) => {
        let va = this.valorOrden(a, campo);
        let vb = this.valorOrden(b, campo);
        if (va < vb) return -1 * dir;
        if (va > vb) return  1 * dir;
        return 0;
      });
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.filasFiltradas.length / POR_PAGINA));
    },
    filasPaginadas() {
      const ini = (this.paginaActual - 1) * POR_PAGINA;
      return this.filasFiltradas.slice(ini, ini + POR_PAGINA);
    },
  },
  watch: {
    canAdmin: {
      immediate: true,
      handler(isAdmin) {
        if (isAdmin) this.cargarTipsters();
      },
    },
    permisosListos: {
      immediate: true,
      handler(listo) {
        if (listo && !this.canAdmin) this.cargar();
      },
    },
    paginaActual() { window.scrollTo({ top: 0, behavior: "smooth" }); },
  },
  created() {
    try {
      const saved = localStorage.getItem(COLS_STORAGE_KEY);
      if (saved) this.colsV = { ...COLS_DEFAULT, ...JSON.parse(saved) };
      else if (window.innerWidth < 768) this.colsV = { ...COLS_MOBILE };
    } catch { /* storage no disponible */ }
  },
  methods: {
    guardarCols() {
      try { localStorage.setItem(COLS_STORAGE_KEY, JSON.stringify(this.colsV)); } catch { /* */ }
    },
    resetCols() {
      this.colsV = { ...(window.innerWidth < 768 ? COLS_MOBILE : COLS_DEFAULT) };
      this.guardarCols();
    },
    valorOrden(row, campo) {
      if (campo === "fecha_fin") return row.cancelada_at || row.vencida_at || "";
      if (campo === "importe")   return parseFloat(row.importe) || 0;
      if (campo === "num_pagos") return parseInt(row.num_pagos) || 0;
      return row[campo] ?? "";
    },
    ordenar(campo) {
      if (this.ordenCampo === campo) {
        this.ordenDir = this.ordenDir === "asc" ? "desc" : "asc";
      } else {
        this.ordenCampo = campo;
        this.ordenDir   = campo === "fecha_alta" ? "desc" : "asc";
      }
      this.paginaActual = 1;
    },
    iconOrden(campo) {
      if (this.ordenCampo !== campo) return "↕";
      return this.ordenDir === "asc" ? "↑" : "↓";
    },
    setEstado(estado) {
      this.filtroEstado = estado;
      this.paginaActual = 1;
      this.cargar();
    },
    onBuscar() {
      clearTimeout(buscarTimer);
      buscarTimer = setTimeout(() => {
        this.paginaActual = 1;
        this.cargar();
      }, 400);
    },
    async cargarTipsters() {
      try {
        const resp = await this.$store.dispatch("auth/listaTipsters", {});
        this.tipsters = Array.isArray(resp) ? resp : (resp?.data || []);
      } catch (e) { console.error(e); }
    },
    aplicarPeriodo(value) {
      this.periodoActivo = value;
      if (value === 'custom') return;
      const hoy = new Date();
      const f   = d => d.toISOString().slice(0, 10);
      if (value === 'all') {
        this.fechaDesde = ''; this.fechaHasta = '';
      } else if (value === 'mes') {
        this.fechaDesde = f(new Date(hoy.getFullYear(), hoy.getMonth(), 1));
        this.fechaHasta = f(hoy);
      } else if (value === 'hoy') {
        this.fechaDesde = f(hoy); this.fechaHasta = f(hoy);
      } else if (value === 'hoy_ayer') {
        const ayer = new Date(hoy); ayer.setDate(ayer.getDate() - 1);
        this.fechaDesde = f(ayer); this.fechaHasta = f(hoy);
      } else if (value === 'anio') {
        this.fechaDesde = f(new Date(hoy.getFullYear(), 0, 1));
        this.fechaHasta = f(hoy);
      }
      this.cargar();
    },

    setTipoFecha(tipo) {
      this.tipoFecha = this.tipoFecha === tipo ? null : tipo;
      this.cargar();
    },

    async cargar() {
      this.loading = true;
      try {
        const params = {};
        if (this.filtroEstado) params.estado = this.filtroEstado;
        if (this.filtroTexto)  params.buscar  = this.filtroTexto;
        if (this.tipoFecha && this.fechaDesde) params.desde      = this.fechaDesde;
        if (this.tipoFecha && this.fechaHasta) params.hasta      = this.fechaHasta;
        if (this.tipoFecha)                    params.tipo_fecha = this.tipoFecha;

        let resp;
        if (this.canAdmin) {
          let tid = this.tipsterId
            ? parseInt(this.tipsterId)
            : (this.$store.state.auth?.me?.data?.attributes?.tipster?.id ?? null);
          if (!tid && this.tipsters.length) tid = this.tipsters[0].id;
          if (!tid) { this.lista = []; this.total = 0; return; }
          resp = await this.$store.dispatch("auth/suscripcionesListaAdmin", { tipsterId: tid, params });
        } else {
          resp = await this.$store.dispatch("auth/suscripcionesLista", params);
        }

        this.lista  = Array.isArray(resp?.lista) ? resp.lista : [];
        this.total  = resp?.total ?? this.lista.length;
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: "No se pudo cargar el listado", width: 480 });
      } finally {
        this.loading = false;
      }
    },
    badgeClase(estado) {
      return { activa: "badge-activa", gracia: "badge-gracia", vencida: "badge-vencida", cancelada: "badge-cancelada" }[estado] || "";
    },
    estadoLabel(estado) {
      return { activa: "Activa", gracia: "En gracia", vencida: "Vencida", cancelada: "Cancelada" }[estado] || estado;
    },
    cicloLabel(tipo) {
      return { diario: "Diaria", semanal: "Semanal", quincenal: "Quincenal", mensual: "Mensual", trimestral: "Trimestral", semestral: "Semestral", anual: "Anual" }[tipo] || tipo || "";
    },
    cicloCorto(tipo) {
      return { diario: "día", semanal: "sem", quincenal: "quin", mensual: "mes", trimestral: "trim", semestral: "sem", anual: "año" }[tipo] || "período";
    },
    fmtFecha(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d)) return val;
      return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
    },
    fmtFechaHora(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d)) return val;
      return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
    },
    fmtHora(val) {
      if (!val) return "";
      const d = new Date(val);
      if (isNaN(d)) return "";
      return d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
    },
    fmtMoney(val, moneda) {
      const n = parseFloat(val) || 0;
      if (moneda === "USD") return n.toLocaleString("en-US", { style: "currency", currency: "USD" });
      return n.toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
    esProximo(fecha) {
      if (!fecha) return false;
      const diff = new Date(fecha) - new Date();
      return diff > 0 && diff < 7 * 24 * 3600 * 1000;
    },
    async verRespStripe(s) {
      this.stripeResp.loading  = s.suscripcion_id;
      this.stripeResp.visible  = false;
      try {
        const token = JSON.parse(localStorage.getItem("userF"));
        let tid = this.canAdmin
          ? (this.tipsterId ? parseInt(this.tipsterId) : (this.$store.state.auth?.me?.data?.attributes?.tipster?.id ?? null))
          : (this.$store.state.auth?.me?.data?.attributes?.tipster?.id ?? null);
        if (!tid && this.tipsters.length) tid = this.tipsters[0].id;

        const url = `${process.env.VUE_APP_API_BASE_URL}/api/v2/tipster/panel/${tid}/pedido/${s.pedido_id}/historial`;
        const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

        const eventos = res.data?.eventos || [];
        const pagos   = eventos.filter(e => ['pago_ok','pago_recuperado','pago_fallido'].includes(e.tipo));
        const ultimo  = pagos.length ? pagos[pagos.length - 1] : null;
        // Si no hay eventos de pago, buscar el evento cancelada para mostrar contexto
        const evCancelada = !ultimo ? eventos.findLast?.(e => e.tipo === 'cancelada') ?? eventos.slice().reverse().find(e => e.tipo === 'cancelada') : null;

        this.stripeResp.tipo     = ultimo?.tipo || (evCancelada ? 'cancelada' : null);
        this.stripeResp.motivo   = ultimo?.motivo || null;
        this.stripeResp.importe  = ultimo?.importe || null;
        this.stripeResp.moneda   = ultimo?.moneda || null;
        this.stripeResp.fecha    = ultimo?.fecha || evCancelada?.fecha || null;
        this.stripeResp.email    = s.email;
        this.stripeResp.producto = s.producto;
        this.stripeResp.visible  = true;
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: "No se pudo consultar Stripe." });
      } finally {
        this.stripeResp.loading = null;
      }
    },
    async abrirHistorial(s) {
      this.historial.loading  = s.suscripcion_id;
      this.historial.visible  = true;
      this.historial.eventos  = [];
      this.historial.email    = s.email;
      this.historial.producto = s.producto;
      try {
        const token = JSON.parse(localStorage.getItem("userF"));
        let tid = this.canAdmin
          ? (this.tipsterId ? parseInt(this.tipsterId) : (this.$store.state.auth?.me?.data?.attributes?.tipster?.id ?? null))
          : (this.$store.state.auth?.me?.data?.attributes?.tipster?.id ?? null);
        if (!tid && this.tipsters.length) tid = this.tipsters[0].id;
        const url = `${process.env.VUE_APP_API_BASE_URL}/api/v2/tipster/panel/${tid}/pedido/${s.pedido_id}/historial`;
        const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
        this.historial.eventos = res.data?.eventos || [];
      } catch {
        this.historial.eventos = [];
      } finally {
        this.historial.loading = null;
      }
    },
    cerrarHistorial() {
      this.historial.visible = false;
      this.historial.eventos = [];
    },
    labelHistorial(tipo, idx) {
      if (tipo === 'pago_ok' || tipo === 'pago_recuperado') {
        const previos = this.historial.eventos.slice(0, idx).filter(e => e.tipo === 'pago_ok' || e.tipo === 'pago_recuperado').length;
        if (tipo === 'pago_recuperado') return 'Pago recuperado';
        return previos === 0 ? 'Primer pago' : 'Renovación';
      }
      return { creada: 'Alta', pago_fallido: 'Pago fallido', cancelada: 'Cancelada', vencida: 'Vencida' }[tipo] || tipo;
    },
    async reintentar(s) {
      this.reintentando = s.suscripcion_id;
      try {
        const token = JSON.parse(localStorage.getItem("userF"));
        let url;
        if (this.canAdmin) {
          let tid = this.tipsterId
            ? parseInt(this.tipsterId)
            : (this.$store.state.auth?.me?.data?.attributes?.tipster?.id ?? null);
          if (!tid && this.tipsters.length) tid = this.tipsters[0].id;
          url = `${process.env.VUE_APP_API_BASE_URL}/api/v2/tipster/panel/${tid}/reintentar-pago`;
        } else {
          url = `${process.env.VUE_APP_API_BASE_URL}/api/v2/tipster/panel/suscripciones/reintentar-pago`;
        }
        const res = await axios.post(url, { suscripcion_id: s.suscripcion_id }, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data?.res === "OK") {
          showSwal.methods.showSwal({ type: "success", message: "Reintento lanzado. Stripe procesará el cobro y enviará el enlace si el pago se concreta." });
        } else {
          showSwal.methods.showSwal({ type: "error", message: res.data?.mensaje || "Error al reintentar el pago." });
        }
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: e?.response?.data?.mensaje || "Error de red al reintentar el pago." });
      } finally {
        this.reintentando = null;
      }
    },
    async reintentarTodos() {
      const resultado = await showSwal.methods.showConfirm({
        title: "¿Reintentar cobro masivo?",
        message: "Se reintentará el cobro en TODAS las suscripciones en gracia y vencidas de este tipster. Si el pago se concreta, la suscripción se reactivará automáticamente.",
        type: "warning",
        confirmButtonText: "Sí, reintentar todos",
        cancelButtonText: "Cancelar",
        width: 480,
      });
      if (!resultado.isConfirmed) return;

      this.reintentandoTodos = true;
      try {
        const token = JSON.parse(localStorage.getItem("userF"));
        let url;
        if (this.canAdmin) {
          let tid = this.tipsterId
            ? parseInt(this.tipsterId)
            : (this.$store.state.auth?.me?.data?.attributes?.tipster?.id ?? null);
          if (!tid && this.tipsters.length) tid = this.tipsters[0].id;
          url = `${process.env.VUE_APP_API_BASE_URL}/api/v2/tipster/panel/${tid}/reintentar-pago-masivo`;
        } else {
          url = `${process.env.VUE_APP_API_BASE_URL}/api/v2/tipster/panel/suscripciones/reintentar-pago-masivo`;
        }
        const res = await axios.post(url, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const d = res.data;
        if (d?.res === "OK") {
          showSwal.methods.showSwal({
            type: "success",
            message: d.mensaje || `Reintento masivo completado: ${d.ok} de ${d.intentados} procesados.`,
          });
          this.cargar();
        } else {
          showSwal.methods.showSwal({ type: "error", message: d?.mensaje || "Error al reintentar." });
        }
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: e?.response?.data?.mensaje || "Error de red al reintentar." });
      } finally {
        this.reintentandoTodos = false;
      }
    },
  },
};
</script>

<style scoped>
.tabla-wrap { overflow-x: auto; }

.tabla-susc {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.tabla-susc thead th {
  padding: 8px 10px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: var(--q-text-muted, #8898aa);
  border-bottom: 1px solid var(--q-border);
  white-space: nowrap;
}
.th-ord { cursor: pointer; user-select: none; }
.th-ord:hover { color: var(--q-gold, #d4af37); }
.ord-icon { font-size: 10px; opacity: .6; }

.tabla-susc tbody td {
  padding: 9px 10px;
  border-bottom: 1px solid rgba(255,255,255,.04);
  vertical-align: middle;
}
.fila-susc:hover td { background: rgba(255,255,255,.03); }

.badge-susc {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.badge-activa    { background: rgba(40,167,69,.2);  color: #4caf50; }
.badge-gracia    { background: rgba(255,193,7,.2);  color: #ffc107; }
.badge-vencida   { background: rgba(239,83,80,.2);  color: #ef5350; }
.badge-cancelada { background: rgba(100,100,100,.2);color: #9e9e9e; }
.badge-todos     { background: var(--q-hover, rgba(255,255,255,.06)); color: var(--q-muted, #9ca3af); }
.td-estado { text-align: center; }
.susc-estado-cel {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}
.susc-cancel-prog-chip {
  font-size: 0.67rem;
  color: #f87171;
  white-space: nowrap;
}
.badge-kick-fallo {
  display: inline-block; margin-left: 5px;
  padding: 1px 6px; border-radius: 10px; font-size: 10px; font-weight: 700;
  background: rgba(255,152,0,.18); color: #ff9800;
  border: 1px solid rgba(255,152,0,.4);
  cursor: default;
}

.td-susc { min-width: 180px; }
.susc-id     { font-size: 11px; color: var(--q-gold, #d4af37); font-weight: 700; display: block; }
.susc-cliente{ display: flex; flex-direction: column; }
.susc-nombre { font-size: 12px; font-weight: 600; }
.susc-email  { font-size: 11px; opacity: .6; }

.td-prod { min-width: 140px; }
.prod-nombre { display: block; font-weight: 500; }
.prod-ciclo  { display: block; font-size: 11px; opacity: .6; }

.td-total { white-space: nowrap; font-weight: 600; color: var(--q-gold, #d4af37); }
.ciclo-abbr { font-size: 11px; font-weight: 400; opacity: .6; }

.td-fecha { white-space: nowrap; font-size: 12px; }
.fecha-dia  { display: block; }
.fecha-hora { display: block; font-size: 11px; opacity: .6; }
.td-pagos { text-align: center; }
.num-pagos { font-weight: 700; }

.text-danger-soft { color: #ef5350; }
.text-muted-soft  { color: #9e9e9e; }
.opacity-4 { opacity: .4; }

.toolbar-susc {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.input-buscar {
  flex: 1;
  min-width: 200px;
  max-width: 340px;
  background: var(--q-input-bg, rgba(255,255,255,.06));
  border: 1px solid var(--q-border);
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  color: var(--q-text);
  outline: none;
}
.input-buscar:focus { border-color: var(--q-gold, #d4af37); }

.susc-periodo-wrap { border-bottom: 1px solid var(--q-border); padding-bottom: 12px; margin-bottom: 4px; }
.periodo-btns { display: flex; gap: 6px; flex-wrap: wrap; }
.btn-periodo {
  padding: 5px 14px; border-radius: 8px;
  border: 1px solid var(--q-border-md);
  background: transparent; color: var(--q-muted);
  font-size: .8rem; cursor: pointer;
  transition: color .15s, border-color .15s, background .15s;
  white-space: nowrap;
}
.btn-periodo:hover:not(:disabled) { border-color: var(--q-gold); color: var(--q-text); }
.btn-periodo.active {
  background: var(--q-gold); border-color: var(--q-gold);
  color: #140c00; font-weight: 600;
}
.btn-periodo:disabled { opacity: .5; cursor: not-allowed; }
.custom-dates { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.date-input {
  max-width: 150px; font-size: .85rem;
  background: var(--q-card); color: var(--q-text);
  border-color: var(--q-border-md);
}
.date-input:focus { border-color: var(--q-gold); box-shadow: none; }
.sep-dash { color: var(--q-muted); font-size: .9rem; }

.susc-tipo-fecha-row {
  display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
  background: rgba(255,255,255,.03);
  border: 1px solid var(--q-border);
  border-radius: 10px;
  padding: 8px 14px;
}
.susc-tipo-label { font-size: .8rem; color: var(--q-muted); font-weight: 500; margin-right: 2px; }
.btn-tipo-fecha {
  padding: 5px 16px; border-radius: 20px;
  border: 1.5px solid var(--q-border);
  background: transparent; color: var(--q-text-secondary, var(--q-muted));
  font-size: .82rem; font-weight: 500; cursor: pointer;
  display: inline-flex; align-items: center; gap: 6px;
  transition: border-color .15s, background .15s, color .15s, box-shadow .15s;
}
.btn-tipo-fecha i { font-size: .78rem; }
.btn-tipo-fecha:hover { border-color: var(--q-border-md); color: var(--q-text); }
.btn-tipo-alta.active {
  border-color: #4caf7d; color: #4caf7d;
  background: rgba(76,175,125,.12);
  box-shadow: 0 0 0 1px rgba(76,175,125,.2);
}
.btn-tipo-renov.active {
  border-color: #5b9bd5; color: #5b9bd5;
  background: rgba(91,155,213,.12);
  box-shadow: 0 0 0 1px rgba(91,155,213,.2);
}
.susc-tipo-hint {
  font-size: .73rem; color: var(--q-muted);
  font-style: italic; margin-left: 4px;
}

.leyenda-estados { display: flex; flex-wrap: wrap; gap: 6px; }
.ley-item {
  background: none;
  border: 1px solid var(--q-border);
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 11px;
  color: var(--q-text-muted);
  cursor: pointer;
  transition: all .15s;
}
.ley-item:hover      { border-color: var(--q-border-md); }
.ley-item.ley-activo { border-color: var(--q-border-md); background: var(--q-hover); }
.ley-item.ley-activo:has(.badge-activa)   { border-color: #4caf50; }
.ley-item.ley-activo:has(.badge-gracia)   { border-color: #ffc107; }
.ley-item.ley-activo:has(.badge-vencida)  { border-color: #ef5350; }
.ley-item.ley-activo:has(.badge-cancelada){ border-color: #9e9e9e; }
.ley-item.ley-activo:has(.badge-todos)    { border-color: var(--q-border-md); }
.ley-item .badge-susc{ pointer-events: none; }

.total-label { font-size: 12px; opacity: .6; margin-left: auto; }

.paginacion {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.btn-pag {
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 8px;
  padding: 4px 14px;
  font-size: 16px;
  cursor: pointer;
  color: var(--q-text);
}
.btn-pag:disabled { opacity: .3; cursor: default; }
.btn-pag:not(:disabled):hover { border-color: var(--q-gold, #d4af37); }
.pag-info { font-size: 12px; opacity: .7; }

/* Acciones */
.th-acciones { width: 130px; }
.td-acciones { white-space: nowrap; }
.btn-reintentar-masivo {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 14px; border-radius: 8px;
  border: 1.5px solid #5b9bd5;
  background: rgba(91,155,213,.08); color: #5b9bd5;
  font-size: .8rem; font-weight: 500; cursor: pointer;
  transition: background .15s, color .15s, border-color .15s;
  white-space: nowrap;
}
.btn-reintentar-masivo:hover:not(:disabled) {
  background: rgba(91,155,213,.18); color: #7ab4e0;
}
.btn-reintentar-masivo:disabled,
.btn-reintentar-masivo.cargando {
  opacity: .55; cursor: default;
}

.btn-reintentar {
  background: rgba(212,175,55,.15);
  border: 1px solid rgba(212,175,55,.4);
  border-radius: 6px;
  color: var(--q-gold, #d4af37);
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  cursor: pointer;
  transition: all .15s;
  white-space: nowrap;
}
.btn-reintentar:hover:not(:disabled) {
  background: rgba(212,175,55,.3);
  border-color: var(--q-gold, #d4af37);
}
.btn-reintentar:disabled,
.btn-reintentar.cargando {
  opacity: .5;
  cursor: default;
}

.selector-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
.select-block { display: flex; flex-direction: column; }
.select-wrap  { min-width: 220px; }
.selector-actions { padding-bottom: 2px; }

/* Botón Resp. Stripe */
.btn-stripe-resp {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid rgba(99,179,237,.4);
  background: rgba(99,179,237,.08);
  color: #63b3ed;
  cursor: pointer;
  transition: background .15s, border-color .15s;
  white-space: nowrap;
  margin-left: 4px;
}
.btn-stripe-resp:hover:not(:disabled) {
  background: rgba(99,179,237,.2);
  border-color: #63b3ed;
}
.btn-stripe-resp:disabled,
.btn-stripe-resp.cargando { opacity: .5; cursor: default; }

/* Modal Resp. Stripe */
.sresp-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999;
}
.sresp-box {
  background: var(--q-card-bg, #1a1f2e);
  border: 1px solid var(--q-border);
  border-radius: 14px;
  width: 100%;
  max-width: 420px;
  padding: 0;
  box-shadow: 0 20px 60px rgba(0,0,0,.5);
}
.sresp-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 20px 12px;
  border-bottom: 1px solid var(--q-border);
}
.sresp-title { font-size: 14px; font-weight: 700; color: var(--q-gold, #ffd700); }
.sresp-sub   { font-size: 11px; color: var(--q-text-muted); margin: 2px 0 0; }
.sresp-close {
  background: none; border: none; cursor: pointer;
  font-size: 20px; line-height: 1; color: var(--q-text-muted);
  padding: 0 2px;
}
.sresp-body  { padding: 20px; }
.sresp-resultado {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.5;
}
.sresp-ok {
  background: rgba(16,185,129,.1);
  border: 1px solid rgba(16,185,129,.3);
  color: #10b981;
}
.sresp-error {
  background: rgba(239,68,68,.1);
  border: 1px solid rgba(239,68,68,.3);
  color: var(--q-red, #ef4444);
}
.sresp-cancelada {
  background: rgba(100,100,100,.1);
  border: 1px solid rgba(100,100,100,.25);
  color: #9e9e9e;
}
.sresp-resultado-label   { font-weight: 700; margin-bottom: 2px; }
.sresp-resultado-detalle { font-weight: 400; opacity: .85; }
.sresp-icon { font-size: 18px; flex-shrink: 0; margin-top: 1px; }
.sresp-vacio {
  text-align: center;
  color: var(--q-text-muted);
  font-size: 13px;
  padding: 10px 0;
}
.sresp-foot {
  padding: 12px 20px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--q-border);
}

/* Botón historial */
.btn-hist-pagos {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 4px 10px; font-size: 11px; font-weight: 600;
  border-radius: 6px; border: 1px solid rgba(167,139,250,.4);
  background: rgba(167,139,250,.08); color: #a78bfa;
  cursor: pointer; transition: background .15s, border-color .15s;
  white-space: nowrap; margin-left: 4px;
}
.btn-hist-pagos:hover:not(:disabled) { background: rgba(167,139,250,.2); border-color: #a78bfa; }
.btn-hist-pagos:disabled,
.btn-hist-pagos.cargando { opacity: .5; cursor: default; }

/* Modal historial */
.hist-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999; padding: 16px;
}
.hist-box {
  background: var(--q-card); border: 1px solid var(--q-border);
  border-radius: 12px; width: 100%; max-width: 440px;
  box-shadow: 0 8px 32px rgba(0,0,0,.35);
  display: flex; flex-direction: column; max-height: 85vh;
}
.hist-head {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 16px 20px 12px; border-bottom: 1px solid var(--q-border);
  flex-shrink: 0;
}
.hist-title { font-weight: 700; font-size: 15px; color: var(--q-gold, #ffd700); }
.hist-sub    { font-size: 0.75rem; color: var(--q-muted); margin: 2px 0 0; }
.hist-close  {
  background: none; border: none; font-size: 20px; cursor: pointer;
  color: var(--q-muted); line-height: 1; padding: 0 0 0 12px;
}
.hist-body { padding: 14px 20px; overflow-y: auto; flex: 1; }
.hist-empty {
  display: flex; align-items: center; font-size: 0.85rem;
  color: var(--q-muted); font-style: italic; padding: 8px 0;
}
.hist-timeline {
  display: flex; flex-direction: column;
  position: relative; padding-left: 24px;
}
.hist-timeline::before {
  content: ''; position: absolute; left: 7px; top: 10px; bottom: 10px;
  width: 2px; background: var(--q-border);
}
.hist-item {
  display: flex; align-items: flex-start; gap: 14px;
  padding: 10px 0; position: relative;
}
.hist-dot {
  width: 14px; height: 14px; border-radius: 50%;
  border: 2px solid var(--q-border-md); background: var(--q-card);
  flex-shrink: 0; margin-left: -24px; margin-top: 2px;
  z-index: 1; position: relative;
}
.hist-ev-pago_ok .hist-dot,
.hist-ev-pago_recuperado .hist-dot { border-color: var(--q-green); background: var(--q-green-soft); }
.hist-ev-pago_fallido .hist-dot    { border-color: var(--q-red, #ef4444); background: rgba(239,68,68,.1); }
.hist-ev-cancelada .hist-dot,
.hist-ev-vencida .hist-dot         { border-color: var(--q-muted); background: var(--q-card-alt); }
.hist-ev-creada .hist-dot          { border-color: #8b5cf6; background: rgba(139,92,246,.12); }
.hist-content { flex: 1; }
.hist-label   { font-size: 0.85rem; font-weight: 700; color: var(--q-text); }
.hist-ev-pago_ok .hist-label,
.hist-ev-pago_recuperado .hist-label { color: var(--q-green); }
.hist-ev-pago_fallido .hist-label    { color: var(--q-red, #ef4444); }
.hist-ev-cancelada .hist-label,
.hist-ev-vencida .hist-label         { color: var(--q-muted); }
.hist-ev-creada .hist-label          { color: #a78bfa; }
.hist-fecha   { font-size: 0.75rem; color: var(--q-muted); margin-top: 1px; }
.hist-importe { font-size: 0.82rem; font-weight: 700; font-family: var(--q-font-mono); color: var(--q-green); margin-top: 2px; }
.hist-motivo  { font-size: 0.75rem; color: var(--q-red, #ef4444); opacity: .85; margin-top: 2px; }
.hist-foot {
  padding: 12px 20px 16px; display: flex; justify-content: flex-end;
  border-top: 1px solid var(--q-border); flex-shrink: 0;
}

/* Botón toggle columnas */
.btn-cols-toggle {
  background: none; border: none; cursor: pointer;
  color: var(--q-muted); font-size: 14px; padding: 4px 6px;
  transition: color .15s; flex-shrink: 0;
}
.btn-cols-toggle:hover { color: var(--q-gold, #ffd700); }

/* Panel selector columnas */
.toolbar-susc { position: relative; }
.selector-columnas-panel {
  position: absolute; top: calc(100% + 4px); right: 0;
  z-index: 999; background: var(--q-card, #1a1f2b);
  border: 1px solid var(--q-border); border-radius: 12px;
  min-width: 280px; box-shadow: 0 12px 40px rgba(0,0,0,.4); overflow: hidden;
}
.selector-columnas-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 0.65rem 1rem; font-size: 0.8rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: .06em;
  color: var(--q-muted); border-bottom: 1px solid var(--q-border);
  background: var(--q-hover, rgba(255,255,255,.04));
}
.selector-reset {
  font-size: 0.72rem; color: var(--q-gold, #ffd700);
  background: none; border: none; cursor: pointer; padding: 0; opacity: .75;
}
.selector-reset:hover { opacity: 1; }
.selector-columnas-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 2px; padding: 0.5rem;
}
.selector-col-item {
  display: flex; align-items: center; gap: 7px; padding: 6px 10px;
  border-radius: 8px; font-size: 0.8rem; cursor: pointer;
  transition: background .12s; user-select: none;
}
.selector-col-item:hover { background: var(--q-hover, rgba(255,255,255,.06)); }
.selector-col-item input[type="checkbox"] { margin: 0; cursor: pointer; accent-color: var(--q-gold, #ffd700); }
.selector-col-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
</style>
